// Dialog model types. Co-located with the dialog component so the component
// can depend on them without re-entering services/message.service (which would
// create a circular import — dialog.component is referenced by message.service
// for the MatDialog component arg).

export class TellerOnlineDialogOptions {
    content: string;
    title: string;
    actions?: TellerOnlineDialogAction[];
    form?: TellerOnlineDialogForm;
    tables?: TellerOnlineDialogTable[];
    items?: {[key: string]: string};
}

export class TellerOnlineDialogAction {
    text: string;
    color?: "accent"|"warn";
    solidBackground?: boolean = false;
    close?: boolean = null;
    click?: Function;

    constructor(data?: TellerOnlineDialogAction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }
}

export class TellerOnlineDialogForm {
    fields: TellerOnlineDialogFormField[];
}

export class TellerOnlineDialogFormField {
    type: string;
    label: string;
    name: string;
    required?: boolean = false;
    placeholder?: string;
    options?: string[];
}

export interface TellerOnlineDialogTable {
    header?: string;
    columnMetadata: TellerOnlineColumnMetadata[];
    rows: string[][];
    footer?: string[];
    hasColumnHeaderRow: boolean;
}

export interface TellerOnlineColumnMetadata {
    title: string;
    contentAlignment: ColumnContentAlignment
}

export enum ColumnContentAlignment {
    Left = 0,
    Center = 1,
    Right = 2,
}
